import * as v from "valibot";
import { NARRATORS } from "../narrators";
import { SETTING_KEYS, TipKey } from "../settings";
import { aliasField, articleKey } from "./shared.dto";

const frequency = v.picklist(["weekly", "monthly", "never"]);
const onOff = v.picklist(["on", "off"]);

export const userSettingsDto = v.object({
  theme: v.optional(v.picklist(["light", "dark", "system"])),
  narrator: v.optional(v.picklist(NARRATORS)),
  email_feed_updates: v.optional(frequency),
  email_recommendations: v.optional(frequency),
  email_product_announcements: v.optional(onOff),
  email_marketing: v.optional(onOff),
  audio_speed: v.optional(v.picklist(["0.75", "1", "1.25", "1.5", "2"])),
  summary_expanded: v.optional(onOff),
});

export const TIP_KEYS: TipKey[] = Object.values(TipKey);

export const userTipsDto = v.partial(v.object({ playlist_mode: v.boolean() }));

export const MAX_USER_NAME_LENGTH = 100;

export const getUserProfileResponse = {
  id: v.string(),
  email: v.string(),
  name: v.string(),
  settings: userSettingsDto,
  tips: userTipsDto,
};

export const putUserSettingsRequest = {
  settings: v.pipe(v.array(v.object({ key: v.picklist(SETTING_KEYS), value: v.pipe(v.string(), v.maxLength(32)) })), v.minLength(1)),
};

export const putUserTipRequest = {
  tipKey: v.picklist(TIP_KEYS),
  dismissed: v.boolean(),
};

export const putUserNameRequest = {
  name: v.pipe(v.string(), v.minLength(1), v.maxLength(MAX_USER_NAME_LENGTH)),
};
export const putUserNameResponse = putUserNameRequest;

export const getFollowingResponse = {
  /** Aliases of the authors the user follows. */
  authors: v.array(aliasField),
};

export const getArticlesReadResponse = {
  /** "authorAlias:articleId" of every article the user has read. */
  articleIds: v.array(v.string()),
};

/** Marks (PUT) or unmarks (DELETE) an article as read. */
export const articleReadRequest = articleKey;
